import CommentListing from "components/CommentListing/CommentListing";

const Reviews = () => {
  return (
    <div className="w-full rounded-3xl border border-violet-500/40 bg-white/[0.03] shadow-xl backdrop-blur-sm">
      <div className="flex flex-col items-center px-4 py-12 sm:px-10">
        {/* HEADING */}
        <h2 className="text-center text-4xl font-extrabold text-white sm:text-3xl md:text-3xl lg:text-7xl xl:text-7xl">
          NUESTRAS RESEÑAS 💬
        </h2>
        <span className="mt-3 text-lg text-violet-300">Así lo disfrutaron...</span>

        {/* Content */}
        <div className="relative mt-10 w-full overflow-hidden">
          <CommentListing />
        </div>
      </div>
    </div>
  );
};

export default Reviews;
